<script lang="ts" setup>
import { Dayjs } from 'dayjs'

import { StayAction, stayActionLabels } from '@/store/modules/stay/mco/types'

defineProps<{
  isLoading: boolean
  stayActions: StayAction[]
}>()

function formatDate(date: Dayjs): string {
  return `${date.format('DD/MM/YYYY')} à ${date.format('HH:mm')}`
}
</script>

<template>
  <div
    v-if="isLoading"
    class="loader loader-center"
  />
  <div v-else>
    <div v-if="stayActions.length === 0">
      Aucune action
    </div>
    <div
      v-for="stayAction in stayActions"
      v-else
      :key="stayAction.id"
      class="row p-1"
    >
      <div class="col-auto">
        {{ formatDate(stayAction.creationDate) }}
      </div>
      <div class="col text-start">
        {{ stayActionLabels[stayAction.type] }} par {{ stayAction.username }}
      </div>
    </div>
  </div>
</template>
